export enum KestrelInspectionType {
  DEFAULT = 'default',
  ROOFTOP = 'rooftop',
  NAVY = 'navy',
  G1N6 = 'g1n6',
  SITEVIEW = 'siteview',
  AEROSPACE = 'aerospace',
}
